import { VariantFragments } from '@/apollo/fragments/variant';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { PhotoPrintVariantForm } from '@/forms/purchasable/variant/PhotoPrintVariantForm';
import { MutationUpdateTourArgs, Tour } from '@/types/api';
import gql from 'graphql-tag';

@Form({
  apollo: {
    mutation: gql`
      mutation UpdateTour($input: UpdateTourInput!) {
        updateTour(input: $input) {
          tour {
            id
            photos {
              stopDate
              expectedDeliveryAt
              photoPrint {
                id
                title
                description
                price
                variants {
                  ...PhotoPrintVariant
                }
              }
            }
          }
        }
      }
      ${VariantFragments.PhotoPrintVariant}
    `,
    refetchQueries: ['Tour'],
  },
})
export class TourPhotosForm extends GraphQLForm<Tour> {
  private tourId: string;

  @Field()
  public stopDate: Date | null = null;

  @Field()
  public expectedDeliveryAt: Date | null = null;

  @Field()
  public title: string = '';

  @Field()
  public description: string = '';

  @Field()
  public price: number = 0;

  @Field()
  public variantInputs = [new PhotoPrintVariantForm()];

  constructor(tour: Tour) {
    super(tour);
    this.tourId = tour.id;

    this.title = tour.photos?.photoPrint?.title || '';
    this.description = tour.photos?.photoPrint?.description || '';
    this.price = tour.photos?.photoPrint?.price || 0;
    this.variantInputs = tour.photos?.photoPrint?.variants?.map((variant) => new PhotoPrintVariantForm(variant)) ?? [
      new PhotoPrintVariantForm(),
    ];

    this.stopDate = tour.photos?.stopDate ? new Date(tour.photos.stopDate) : null;
    this.expectedDeliveryAt = tour.photos?.expectedDeliveryAt ? new Date(tour.photos.expectedDeliveryAt) : null;
  }

  public save() {
    return super.save({
      variables: {
        input: {
          id: this.tourId,
          photos: this.filteredFieldsData as TourPhotosForm,
        },
      } satisfies MutationUpdateTourArgs,
    });
  }
}
